<!-- ===== EDIT MODE → Lista de miembros con bulk actions ===== -->
@if (showMemberList) {

  @if (drawerTab === 'members') {
  <!-- Barra de acciones bulk (visible cuando hay selección en activos) -->
  @if (selectedMembershipIds.length > 0) {
  <div class="flex items-center gap-2 mb-4 p-3 bg-brand-50 dark:bg-brand-900/20 rounded-xl border border-brand-200 dark:border-brand-800">
    <span class="text-xs font-semibold text-brand-700 dark:text-brand-400 shrink-0">
      {{ selectedMembershipIds.length }} seleccionado{{ selectedMembershipIds.length !== 1 ? 's' : '' }}
    </span>
    <div class="flex gap-1.5 ml-auto shrink-0">
      <button type="button" (click)="ejecutarBulkAction('EXCLUDE')" [disabled]="isExecutingBulk"
        class="px-2.5 py-1.5 text-xs font-semibold rounded-lg bg-amber-50 dark:bg-amber-900/20 text-amber-700 dark:text-amber-400 border border-amber-200 dark:border-amber-800 hover:bg-amber-100 dark:hover:bg-amber-900/30 transition-colors whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed">
        Excluir
      </button>
      <button type="button" (click)="ejecutarBulkAction('DELETE')" [disabled]="isExecutingBulk"
        class="px-2.5 py-1.5 text-xs font-semibold rounded-lg bg-red-50 dark:bg-red-900/20 text-red-600 dark:text-red-400 border border-red-200 dark:border-red-800 hover:bg-red-100 dark:hover:bg-red-900/30 transition-colors whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed">
        Eliminar
      </button>
    </div>
  </div>
  }

  <!-- Barra de acciones re-incluir (visible cuando hay selección en excluidos) -->
  @if (selectedExcludedContactIds.length > 0) {
  <div class="flex items-center gap-2 mb-4 p-3 bg-emerald-50 dark:bg-emerald-900/20 rounded-xl border border-emerald-200 dark:border-emerald-800">
    <span class="text-xs font-semibold text-emerald-700 dark:text-emerald-400 shrink-0">
      {{ selectedExcludedContactIds.length }} excluido{{ selectedExcludedContactIds.length !== 1 ? 's' : '' }} seleccionado{{ selectedExcludedContactIds.length !== 1 ? 's' : '' }}
    </span>
    <div class="flex gap-1.5 ml-auto shrink-0">
      <button type="button" (click)="ejecutarReincluir()" [disabled]="isReincluding"
        class="px-2.5 py-1.5 text-xs font-semibold rounded-lg bg-emerald-600 text-white hover:bg-emerald-700 transition-colors whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed">
        Re-incluir
      </button>
    </div>
  </div>
  }

  <!-- Stats cards -->
  @if (!isLoadingMembers) {
  <div class="grid grid-cols-2 gap-3 mb-4">
    <div class="bg-brand-50/50 dark:bg-brand-900/10 rounded-xl p-4 text-center border border-brand-100 dark:border-brand-800/50">
      <h4 class="text-3xl font-black text-brand-600 dark:text-brand-400">{{ membersTotalElements }}</h4>
      <p class="text-[10px] font-bold text-brand-700/70 dark:text-brand-400/70 mt-1 uppercase tracking-wide">Miembros</p>
    </div>
    <div class="bg-brand-50/50 dark:bg-brand-900/10 rounded-xl p-4 text-center border border-brand-100 dark:border-brand-800/50">
      <h4 class="text-3xl font-black text-brand-600 dark:text-brand-400">{{ membersPercentage }}%</h4>
      <p class="text-[10px] font-bold text-brand-700/70 dark:text-brand-400/70 mt-1 uppercase tracking-wide">Del total</p>
    </div>
    @if (filtersModified) {
    <div class="col-span-2 rounded-xl p-3 border flex items-center justify-between transition-colors"
      [ngClass]="isLoadingPreview
        ? 'bg-gray-50 dark:bg-gray-800/50 border-gray-100 dark:border-gray-700'
        : totalContactosPreview > 0
          ? 'bg-emerald-50 dark:bg-emerald-900/10 border-emerald-100 dark:border-emerald-800/50'
          : 'bg-gray-50 dark:bg-gray-800/50 border-gray-100 dark:border-gray-700'">
      <div>
        <p class="text-[10px] font-bold uppercase tracking-wide mb-0.5"
          [ngClass]="totalContactosPreview > 0 && !isLoadingPreview
            ? 'text-emerald-700/70 dark:text-emerald-400/70'
            : 'text-gray-500/70 dark:text-gray-400/70'">
          A añadir al guardar
        </p>
        @if (isLoadingPreview) {
          <div class="flex items-center gap-1.5">
            <div class="animate-spin rounded-full h-3 w-3 border-b-2 border-gray-400 shrink-0"></div>
            <span class="text-xs text-gray-500 dark:text-gray-400">Calculando...</span>
          </div>
        } @else {
          <span class="text-xs font-medium"
            [ngClass]="totalContactosPreview > 0
              ? 'text-emerald-600 dark:text-emerald-400'
              : 'text-gray-500 dark:text-gray-400'">
            {{ totalContactosPreview > 0 ? 'contactos nuevos' : 'Ningún contacto nuevo' }}
          </span>
        }
      </div>
      @if (!isLoadingPreview) {
      <span class="text-3xl font-black"
        [ngClass]="totalContactosPreview > 0
          ? 'text-emerald-600 dark:text-emerald-400'
          : 'text-gray-400 dark:text-gray-500'">
        {{ totalContactosPreview > 0 ? '+' : '' }}{{ totalContactosPreview }}
      </span>
      }
    </div>
    @if (isLoadingNoCoinciden || totalNoCoinciden > 0) {
    <div class="col-span-2 rounded-xl p-3 border flex items-center justify-between transition-colors"
      [ngClass]="isLoadingNoCoinciden
        ? 'bg-gray-50 dark:bg-gray-800/50 border-gray-100 dark:border-gray-700'
        : 'bg-amber-50 dark:bg-amber-900/10 border-amber-100 dark:border-amber-800/50'">
      <div>
        <p class="text-[10px] font-bold uppercase tracking-wide mb-0.5"
          [ngClass]="isLoadingNoCoinciden ? 'text-gray-500/70 dark:text-gray-400/70' : 'text-amber-700/70 dark:text-amber-400/70'">
          Ya no coinciden
        </p>
        @if (isLoadingNoCoinciden) {
          <div class="flex items-center gap-1.5">
            <div class="animate-spin rounded-full h-3 w-3 border-b-2 border-gray-400 shrink-0"></div>
            <span class="text-xs text-gray-500 dark:text-gray-400">Calculando...</span>
          </div>
        } @else {
          <span class="text-xs font-medium text-amber-600 dark:text-amber-400">
            miembro{{ totalNoCoinciden !== 1 ? 's' : '' }} existente{{ totalNoCoinciden !== 1 ? 's' : '' }}
          </span>
        }
      </div>
      @if (!isLoadingNoCoinciden) {
      <span class="text-3xl font-black text-amber-500 dark:text-amber-400">{{ totalNoCoinciden }}</span>
      }
    </div>
    }
    }
    <div class="col-span-2 bg-gray-50 dark:bg-gray-800/50 rounded-xl p-3 text-center border border-gray-100 dark:border-gray-700 flex items-center justify-center gap-2">
      <span class="text-sm font-black text-gray-800 dark:text-gray-200">{{ totalContactosCrm }}</span>
      <span class="text-xs font-medium text-gray-500 dark:text-gray-400">contactos totales en CRM</span>
    </div>
  </div>
  }

  <!-- Tabla de miembros -->
  <div class="border border-gray-200 dark:border-gray-700 rounded-xl overflow-hidden">
    <div class="overflow-x-auto">
      <table class="min-w-full text-left whitespace-nowrap">
        <thead class="bg-gray-50 dark:bg-gray-800/50 border-b border-gray-200 dark:border-gray-700">
          <tr>
            <th class="px-4 py-3 w-10">
              <input type="checkbox" [checked]="isAllSelected" (change)="toggleAll($event)"
                [disabled]="miembros.length === 0"
                class="w-4 h-4 rounded border-gray-300 text-brand-500 focus:ring-brand-500 cursor-pointer disabled:cursor-not-allowed disabled:opacity-40">
            </th>
            <th class="px-4 py-3 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Nombre</th>
            <th class="px-4 py-3 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Correo</th>
            <th class="px-4 py-3 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Ingresó</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-100 dark:divide-gray-800 bg-white dark:bg-gray-900">

          @if (isLoadingMembers) {
          <tr>
            <td colspan="4" class="px-6 py-12 text-center">
              <div class="animate-spin rounded-full h-7 w-7 border-b-2 border-brand-500 mx-auto mb-3"></div>
              <span class="text-sm text-gray-500 dark:text-gray-400">Cargando miembros...</span>
            </td>
          </tr>
          }

          @if (!isLoadingMembers && miembros.length === 0) {
          <tr>
            <td colspan="4" class="px-6 py-14 text-center">
              <div class="w-12 h-12 bg-gray-50 dark:bg-gray-800 rounded-full flex items-center justify-center mx-auto mb-3 border border-gray-100 dark:border-gray-700">
                <svg class="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/>
                </svg>
              </div>
              <p class="text-sm font-medium text-gray-500 dark:text-gray-400">Este segmento no tiene miembros activos.</p>
              <p class="text-xs text-gray-400 dark:text-gray-500 mt-1">Usa los filtros de la izquierda para agregar contactos.</p>
            </td>
          </tr>
          }

          @for (member of miembros; track member.id) {
          <tr class="hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors"
            [class.bg-brand-50]="isMemberSelected(member.id)"
            [class.dark:bg-brand-900/10]="isMemberSelected(member.id)">
            <td class="px-4 py-3">
              <input type="checkbox" [checked]="isMemberSelected(member.id)" (change)="toggleMember(member.id)"
                class="w-4 h-4 rounded border-gray-300 text-brand-500 focus:ring-brand-500 cursor-pointer">
            </td>
            <td class="px-4 py-3">
              <div class="flex items-center gap-2.5">
                <div class="h-7 w-7 rounded-full bg-brand-100 dark:bg-brand-900/30 text-brand-600 dark:text-brand-400 flex items-center justify-center font-semibold text-xs flex-shrink-0">
                  {{ (member.contact.name || '')[0]?.toUpperCase() || '?' }}
                </div>
                <span class="text-xs font-medium text-gray-900 dark:text-white truncate max-w-[100px]">{{ member.contact.name }}</span>
              </div>
            </td>
            <td class="px-4 py-3 text-xs text-gray-500 dark:text-gray-400 truncate max-w-[110px]">{{ member.contact.email || '—' }}</td>
            <td class="px-4 py-3 text-xs text-gray-500 dark:text-gray-400">{{ member.datetimeCreated | datetime }}</td>
          </tr>
          }

        </tbody>
      </table>
    </div>

    <!-- Paginación miembros -->
    @if (membersTotalElements > membersPageSize) {
    <div class="px-4 py-3 border-t border-gray-100 dark:border-gray-800 flex items-center justify-between bg-gray-50/50 dark:bg-gray-800/30">
      <span class="text-xs text-gray-500 dark:text-gray-400">
        Página {{ membersPage + 1 }} / {{ membersTotalPages }} · {{ membersTotalElements }} miembros
      </span>
      <div class="flex gap-2">
        <button type="button" (click)="previousMembersPage()" [disabled]="membersPage === 0"
          class="px-3 py-1.5 text-xs rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
          ← Anterior
        </button>
        <button type="button" (click)="nextMembersPage()" [disabled]="membersPage >= membersTotalPages - 1"
          class="px-3 py-1.5 text-xs rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
          Siguiente →
        </button>
      </div>
    </div>
    }
  </div>

  <!-- Sección de miembros excluidos (toggle) -->
  <div class="mt-4 pt-4 border-t border-gray-100 dark:border-gray-800">
    <button type="button" (click)="toggleShowExcluidos()"
      class="flex items-center justify-between w-full text-left group">
      <div class="flex items-center gap-2">
        <span class="text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider group-hover:text-gray-700 dark:group-hover:text-gray-200 transition-colors">
          Excluidos
        </span>
        @if (excluidosTotalElements > 0) {
        <span class="bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-400 text-[10px] font-bold px-1.5 py-0.5 rounded">
          {{ excluidosTotalElements }}
        </span>
        }
      </div>
      <svg class="w-3.5 h-3.5 text-gray-400 transition-transform duration-200" [class.rotate-180]="showExcluidos" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
      </svg>
    </button>

    @if (showExcluidos) {
    <div class="mt-3">
      @if (isLoadingExcluidos) {
      <div class="flex items-center gap-2 py-4 justify-center text-gray-400 dark:text-gray-500">
        <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-amber-500 shrink-0"></div>
        <span class="text-xs">Cargando...</span>
      </div>
      } @else if (miembrosExcluidos.length === 0) {
      <div class="text-center py-5 bg-gray-50 dark:bg-gray-800/30 rounded-xl border border-dashed border-gray-300 dark:border-gray-700">
        <p class="text-xs font-medium text-gray-500 dark:text-gray-400 px-4">No hay miembros excluidos en este segmento.</p>
      </div>
      } @else {
      <div class="border border-amber-200 dark:border-amber-800/50 rounded-xl overflow-hidden">
        <div class="overflow-x-auto">
          <table class="min-w-full text-left whitespace-nowrap">
            <thead class="bg-amber-50/60 dark:bg-amber-900/10 border-b border-amber-200 dark:border-amber-800/50">
              <tr>
                <th class="px-4 py-2.5 w-10">
                  <input type="checkbox" [checked]="isAllExcluidosSelected" (change)="toggleAllExcluidos($event)"
                    [disabled]="miembrosExcluidos.length === 0"
                    class="w-4 h-4 rounded border-gray-300 text-emerald-500 focus:ring-emerald-500 cursor-pointer disabled:cursor-not-allowed disabled:opacity-40">
                </th>
                <th class="px-4 py-2.5 text-[10px] font-bold text-amber-700/70 dark:text-amber-400/70 uppercase tracking-wider">Nombre</th>
                <th class="px-4 py-2.5 text-[10px] font-bold text-amber-700/70 dark:text-amber-400/70 uppercase tracking-wider">Correo</th>
                <th class="px-4 py-2.5 text-[10px] font-bold text-amber-700/70 dark:text-amber-400/70 uppercase tracking-wider">Excluido</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-100 dark:divide-gray-800 bg-white dark:bg-gray-900">
              @for (member of miembrosExcluidos; track member.id) {
              <tr class="hover:bg-amber-50/30 dark:hover:bg-amber-900/5 transition-colors"
                [class.bg-emerald-50]="isExcluidoSelected(member.contact.contactId)"
                [class.dark:bg-emerald-900/10]="isExcluidoSelected(member.contact.contactId)">
                <td class="px-4 py-2.5">
                  <input type="checkbox" [checked]="isExcluidoSelected(member.contact.contactId)" (change)="toggleExcluido(member.contact.contactId)"
                    class="w-4 h-4 rounded border-gray-300 text-emerald-500 focus:ring-emerald-500 cursor-pointer">
                </td>
                <td class="px-4 py-2.5">
                  <div class="flex items-center gap-2">
                    <div class="h-6 w-6 rounded-full bg-amber-100 dark:bg-amber-900/30 text-amber-600 dark:text-amber-400 flex items-center justify-center font-semibold text-[10px] flex-shrink-0">
                      {{ (member.contact.name || '')[0]?.toUpperCase() || '?' }}
                    </div>
                    <span class="text-xs font-medium text-gray-700 dark:text-gray-300 truncate max-w-[100px]">{{ member.contact.name }}</span>
                  </div>
                </td>
                <td class="px-4 py-2.5 text-xs text-gray-500 dark:text-gray-400 truncate max-w-[110px]">{{ member.contact.email || '—' }}</td>
                <td class="px-4 py-2.5 text-xs text-gray-500 dark:text-gray-400">{{ member.datetimeUpdated | datetime }}</td>
              </tr>
              }
            </tbody>
          </table>
        </div>
        @if (excluidosTotalElements > membersPageSize) {
        <div class="px-4 py-3 border-t border-amber-100 dark:border-amber-800/50 flex items-center justify-between bg-amber-50/30 dark:bg-amber-900/5">
          <span class="text-xs text-gray-500 dark:text-gray-400">
            Página {{ excluidosPage + 1 }} / {{ excluidosTotalPages }} · {{ excluidosTotalElements }} excluidos
          </span>
          <div class="flex gap-2">
            <button type="button" (click)="previousExcluidosPage()" [disabled]="excluidosPage === 0"
              class="px-3 py-1.5 text-xs rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
              ← Anterior
            </button>
            <button type="button" (click)="nextExcluidosPage()" [disabled]="excluidosPage >= excluidosTotalPages - 1"
              class="px-3 py-1.5 text-xs rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
              Siguiente →
            </button>
          </div>
        </div>
        }
      </div>
      }
    </div>
    }
  </div>

  } <!-- /drawerTab members -->

  @if (drawerTab === 'match') {
  <!-- Candidatos según filtros actuales (solo visible cuando el usuario ha modificado los filtros) -->
  @if (filtersModified) {
  <div class="mt-5 pt-5 border-t border-gray-100 dark:border-gray-800">

    <div class="mb-3">
      <h4 class="text-xs font-bold text-gray-700 dark:text-gray-300 uppercase tracking-wider">Coinciden con el filtro</h4>
      <p class="text-[10px] text-gray-400 dark:text-gray-500 mt-0.5">Contactos nuevos que se añadirán al guardar.</p>
    </div>

    @if (isLoadingPreview) {
    <div class="flex items-center gap-2 py-4 justify-center text-gray-400 dark:text-gray-500">
      <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-brand-500 shrink-0"></div>
      <span class="text-xs">Calculando...</span>
    </div>
    } @else if (rulesLength === 0) {
    <div class="text-center py-5 bg-gray-50 dark:bg-gray-800/30 rounded-xl border border-dashed border-gray-300 dark:border-gray-700">
      <p class="text-xs font-medium text-gray-500 dark:text-gray-400 px-4">Agrega una condición de filtrado para ver qué contactos nuevos se añadirán.</p>
    </div>
    } @else if (contactosPreview.length === 0) {
    <div class="text-center py-5 bg-gray-50 dark:bg-gray-800/30 rounded-xl border border-dashed border-gray-300 dark:border-gray-700">
      <p class="text-xs font-medium text-gray-500 dark:text-gray-400 px-4">Ningún contacto nuevo cumple el filtro. Los miembros actuales se conservan.</p>
    </div>
    } @else {

    <div class="border border-gray-200 dark:border-gray-700 rounded-xl bg-white dark:bg-gray-900 overflow-hidden">
      <table class="w-full text-left whitespace-nowrap">
        <thead class="bg-gray-50 dark:bg-gray-800/50 border-b border-gray-200 dark:border-gray-700">
          <tr>
            <th class="px-4 py-2.5 text-[10px] font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Nombre</th>
            <th class="px-4 py-2.5 text-[10px] font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Contacto</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-100 dark:divide-gray-800">
          @for (contacto of contactosPreview; track contacto.id) {
          <tr class="transition-colors">
            <td class="px-4 py-2.5">
              <div class="flex items-center gap-2">
                <div class="h-6 w-6 rounded-full bg-brand-100 dark:bg-brand-900/30 text-brand-600 dark:text-brand-400 flex items-center justify-center font-semibold text-[10px] flex-shrink-0">
                  {{ (contacto.fullname || '')[0]?.toUpperCase() || '?' }}
                </div>
                <span class="text-xs font-medium text-gray-900 dark:text-white truncate max-w-[90px]">
                  {{ contacto.fullname }} {{ contacto.lastname }}
                </span>
              </div>
            </td>
            <td class="px-4 py-2.5">
              <span class="text-xs text-gray-500 dark:text-gray-400 truncate max-w-[90px] block">
                {{ contacto.mail || contacto.phone || '—' }}
              </span>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>

    @if (previewTotalPages > 1) {
    <div class="flex items-center justify-between mt-3 px-1">
      <button type="button" (click)="pageChange.emit(previewPage - 1)" [disabled]="previewPage === 0"
        class="px-3 py-1.5 text-xs font-semibold rounded-lg border border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
        ← Anterior
      </button>
      <span class="text-xs text-gray-500 dark:text-gray-400 font-medium">{{ previewPage + 1 }} / {{ previewTotalPages }}</span>
      <button type="button" (click)="pageChange.emit(previewPage + 1)" [disabled]="previewPage >= previewTotalPages - 1"
        class="px-3 py-1.5 text-xs font-semibold rounded-lg border border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
        Siguiente →
      </button>
    </div>
    }

    }
  </div>
  }

  } <!-- /drawerTab match -->

  @if (drawerTab === 'no-match') {
  <!-- Miembros que ya no coinciden con el nuevo filtro -->
  @if (filtersModified && (isLoadingNoCoinciden || totalNoCoinciden > 0)) {
  <div class="mt-5 pt-5 border-t border-gray-100 dark:border-gray-800">

    <div class="mb-3">
      <h4 class="text-xs font-bold text-amber-700 dark:text-amber-400 uppercase tracking-wider">Ya no coinciden con el filtro</h4>
      <p class="text-[10px] text-gray-400 dark:text-gray-500 mt-0.5">Miembros existentes que no cumplen el nuevo filtro. Se conservan en el segmento a menos que los excluyas manualmente.</p>
    </div>

    @if (isLoadingNoCoinciden) {
    <div class="flex items-center gap-2 py-4 justify-center text-gray-400 dark:text-gray-500">
      <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-amber-500 shrink-0"></div>
      <span class="text-xs">Calculando...</span>
    </div>
    } @else if (contactosNoCoinciden.length > 0) {

    <div class="border border-amber-200 dark:border-amber-800/50 rounded-xl bg-white dark:bg-gray-900 overflow-hidden">
      <table class="w-full text-left whitespace-nowrap">
        <thead class="bg-amber-50/60 dark:bg-amber-900/10 border-b border-amber-200 dark:border-amber-800/50">
          <tr>
            <th class="px-4 py-2.5 text-[10px] font-bold text-amber-700/70 dark:text-amber-400/70 uppercase tracking-wider">Nombre</th>
            <th class="px-4 py-2.5 text-[10px] font-bold text-amber-700/70 dark:text-amber-400/70 uppercase tracking-wider">Contacto</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-100 dark:divide-gray-800">
          @for (contacto of contactosNoCoinciden; track contacto.id) {
          <tr class="transition-colors hover:bg-amber-50/40 dark:hover:bg-amber-900/5">
            <td class="px-4 py-2.5">
              <div class="flex items-center gap-2">
                <div class="h-6 w-6 rounded-full bg-amber-100 dark:bg-amber-900/30 text-amber-600 dark:text-amber-400 flex items-center justify-center font-semibold text-[10px] flex-shrink-0">
                  {{ (contacto.fullname || '')[0]?.toUpperCase() || '?' }}
                </div>
                <span class="text-xs font-medium text-gray-900 dark:text-white truncate max-w-[90px]">
                  {{ contacto.fullname }} {{ contacto.lastname }}
                </span>
              </div>
            </td>
            <td class="px-4 py-2.5">
              <span class="text-xs text-gray-500 dark:text-gray-400 truncate max-w-[90px] block">
                {{ contacto.mail || contacto.phone || '—' }}
              </span>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>

    @if (noCoincidentTotalPages > 1) {
    <div class="flex items-center justify-between mt-3 px-1">
      <button type="button" (click)="noCoincidentPageChange.emit(noCoincidentPage - 1)" [disabled]="noCoincidentPage === 0"
        class="px-3 py-1.5 text-xs font-semibold rounded-lg border border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
        ← Anterior
      </button>
      <span class="text-xs text-gray-500 dark:text-gray-400 font-medium">{{ noCoincidentPage + 1 }} / {{ noCoincidentTotalPages }}</span>
      <button type="button" (click)="noCoincidentPageChange.emit(noCoincidentPage + 1)" [disabled]="noCoincidentPage >= noCoincidentTotalPages - 1"
        class="px-3 py-1.5 text-xs font-semibold rounded-lg border border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
        Siguiente →
      </button>
    </div>
    }

    }
  </div>
  }
  } <!-- /drawerTab no-match -->

}

<!-- ===== CREATE MODE → Preview de candidatos por filtros ===== -->
@if (!showMemberList) {

  @if (rulesLength > 0 && !isLoadingPreview) {
  <div class="grid grid-cols-2 gap-3 mb-6">
    <div class="bg-brand-50/50 dark:bg-brand-900/10 rounded-xl p-4 text-center border border-brand-100 dark:border-brand-800/50">
      <h4 class="text-3xl font-black text-brand-600 dark:text-brand-400">{{ totalContactosPreview }}</h4>
      <p class="text-[10px] font-bold text-brand-700/70 dark:text-brand-400/70 mt-1 uppercase tracking-wide">Cumplen</p>
    </div>
    <div class="bg-brand-50/50 dark:bg-brand-900/10 rounded-xl p-4 text-center border border-brand-100 dark:border-brand-800/50">
      <h4 class="text-3xl font-black text-brand-600 dark:text-brand-400">{{ porcentajePreview }}%</h4>
      <p class="text-[10px] font-bold text-brand-700/70 dark:text-brand-400/70 mt-1 uppercase tracking-wide">Del total</p>
    </div>
    <div class="col-span-2 bg-gray-50 dark:bg-gray-800/50 rounded-xl p-3 text-center border border-gray-100 dark:border-gray-700 flex items-center justify-center gap-2">
      <span class="text-sm font-black text-gray-800 dark:text-gray-200">{{ totalContactosCrm }}</span>
      <span class="text-xs font-medium text-gray-500 dark:text-gray-400">contactos totales en CRM</span>
    </div>
  </div>
  }

  @if (isLoadingPreview) {
  <div class="flex flex-col justify-center items-center py-10">
    <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500 mb-2"></div>
    <span class="text-xs text-gray-500 dark:text-gray-400">Calculando...</span>
  </div>
  } @else if (rulesLength === 0) {
  <div class="text-center py-16">
    <div class="w-16 h-16 bg-gray-50 dark:bg-gray-800 rounded-full flex items-center justify-center mx-auto mb-4 border border-gray-100 dark:border-gray-700">
      <svg class="w-8 h-8 text-gray-300 dark:text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
      </svg>
    </div>
    <p class="text-sm text-gray-500 dark:text-gray-400 mx-auto">Agrega criterios de segmentación para ver la simulación en vivo.</p>
  </div>
  } @else if (contactosPreview.length === 0) {
  <div class="text-center py-10 bg-gray-50 dark:bg-gray-800/30 rounded-xl border border-dashed border-gray-300 dark:border-gray-700">
    <p class="text-sm font-medium text-gray-500 dark:text-gray-400 px-4">Ningún contacto cumple con los criterios actuales.</p>
  </div>
  } @else {

  <div class="flex items-center justify-between mb-3">
    <h4 class="text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Afectados</h4>
    @if (contactosAExcluirIds.size > 0) {
    <span class="bg-red-50 dark:bg-red-900/20 text-red-500 px-2 py-0.5 rounded text-[10px] font-bold">
      {{ contactosAExcluirIds.size }} excluido{{ contactosAExcluirIds.size !== 1 ? 's' : '' }}
    </span>
    } @else {
    <span class="bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-300 px-2 py-0.5 rounded text-[10px] font-bold">
      Max {{ totalContactosPreview }}
    </span>
    }
  </div>

  <div class="border border-gray-200 dark:border-gray-700 rounded-xl bg-white dark:bg-gray-900 shadow-sm overflow-hidden">
    <table class="w-full text-left whitespace-nowrap">
      <thead class="bg-gray-50 dark:bg-gray-800/50 border-b border-gray-200 dark:border-gray-700">
        <tr>
          <th class="px-4 py-3 text-[10px] font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Nombre</th>
          <th class="px-4 py-3 text-[10px] font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Contacto</th>
          <th class="px-3 py-3"></th>
        </tr>
      </thead>
      <tbody class="divide-y divide-gray-100 dark:divide-gray-800">
        @for (contacto of contactosPreview; track contacto.id) {
        <tr class="transition-colors" [class.opacity-40]="contactosAExcluirIds.has(contacto.id!)">
          <td class="px-4 py-3">
            <span class="block text-xs font-bold text-gray-900 dark:text-white truncate max-w-[100px]"
              [class.line-through]="contactosAExcluirIds.has(contacto.id!)">
              {{ contacto.fullname }} {{ contacto.lastname }}
            </span>
          </td>
          <td class="px-4 py-3">
            <span class="block text-xs text-gray-600 dark:text-gray-400 truncate max-w-[100px]">
              {{ contacto.mail || contacto.phone || 'Sin datos' }}
            </span>
          </td>
          <td class="px-3 py-3 text-right">
            @if (contactosAExcluirIds.has(contacto.id!)) {
            <button type="button" (click)="excludeToggle.emit(contacto.id!)"
              class="px-2.5 py-1 text-[10px] font-bold text-green-600 bg-green-50 dark:bg-green-900/20 rounded-lg hover:bg-green-100 transition-colors">
              Incluir
            </button>
            } @else {
            <button type="button" (click)="excludeToggle.emit(contacto.id!)"
              class="px-2.5 py-1 text-[10px] font-bold text-red-600 bg-red-50 dark:bg-red-900/20 rounded-lg hover:bg-red-100 transition-colors">
              Excluir
            </button>
            }
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>

  @if (previewTotalPages > 1) {
  <div class="flex items-center justify-between mt-3 px-1">
    <button type="button" (click)="pageChange.emit(previewPage - 1)" [disabled]="previewPage === 0"
      class="px-3 py-1.5 text-xs font-semibold rounded-lg border border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
      ← Anterior
    </button>
    <span class="text-xs text-gray-500 dark:text-gray-400 font-medium">{{ previewPage + 1 }} / {{ previewTotalPages }}</span>
    <button type="button" (click)="pageChange.emit(previewPage + 1)" [disabled]="previewPage >= previewTotalPages - 1"
      class="px-3 py-1.5 text-xs font-semibold rounded-lg border border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
      Siguiente →
    </button>
  </div>
  }

  }

}
